import React, { useState, useEffect } from "react";
import { Container, Grow } from "@material-ui/core";
import { useDispatch } from "react-redux";
//import Solus from "./images/solus.jpg";
import useStyles from "./styles";

import Form from "./components/form/form";
import PostContainer from "./components/postcontainer/postcontainer";

import { getPosts } from "./actions/posts";

function App()
{

  const [currentId, setCurrentId] = useState(null);
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() =>
  {
    dispatch(getPosts());
  }, [dispatch])

  return (
    <Container className={classes.mainContainer}>
      <Container className={classes.subContainer}>
        <Form currentId={currentId} setCurrentId={setCurrentId} />
        <PostContainer setCurrentId={setCurrentId} />
      </Container>
    </Container>
  );
}

export default App;
